import { render, staticRenderFns } from "./BrandForm.vue?vue&type=template&id=ad1edbc0&"
import script from "./BrandForm.vue?vue&type=script&lang=ts&"
export * from "./BrandForm.vue?vue&type=script&lang=ts&"
import style0 from "./BrandForm.vue?vue&type=style&index=0&id=ad1edbc0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports